import './_navigation-menu.scss';
import component from './navigation-menu';

export default component;
